<template>
    <span
        class="badge-container"
        :ariaLabel="ariaLabel"
        :class="[
            size && `size_${size}`,
            color && `color_${color}`,
            circle && `circle`,
            fullWidth && `width`,
            iconPosition && `icon_position_${iconPosition}`,
        ]">
        <Loading v-if="loading" size="xxs" :noPadding="true" />
        <Icon
            v-else-if="icon"
            :type="icon"
            :rotate="iconRotate"
            :size="iconSize"
            v-tippy="iconTooltip" />
        <span v-if="text" class="badge-text">
            {{ text }}
            <span v-if="textNoBold" class="normal">{{ textNoBold }}</span>
        </span>
    </span>
</template>

<script lang="ts">
    import { computed, PropType, defineComponent } from 'vue';
    import { Color, IconPosition, Size } from './Badge.interfaces';
    import { Type as IconType, Size as IconSize } from '@ui/components/Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';
    import Loading from '../Loading/Loading.vue';

    export default defineComponent({
        name: 'Badge',
        components: { Icon, Loading },
        props: {
            text: {
                type: String as PropType<string | number | undefined>,
                default: '',
            },
            textNoBold: {
                type: String as PropType<string | number | Date | undefined>,
                default: '',
            },
            size: {
                type: String as PropType<Size>,
                default: 's',
            },
            color: {
                type: String as PropType<Color>,
                default: 'primary',
            },
            icon: {
                type: String as PropType<IconType | null>,
                default: null,
            },
            iconPosition: {
                type: String as PropType<IconPosition>,
                default: 'left',
            },
            iconSize: {
                type: String as PropType<IconSize>,
                default: 'xs',
            },
            iconRotate: Number,
            iconTooltip: {
                type: String as PropType<string | null>,
                default: '',
            },
            ariaLabel: {
                type: String,
            },
            loading: Boolean,
            fullWidth: Boolean,
        },
        setup(props) {
            const circle = computed(() => {
                const { icon, text } = props;

                return (!icon && text && text.toString().length <= 2) || (icon && !text);
            });

            return {
                circle,
            };
        },
    });
</script>

<style lang="scss">
    @forward './Badge.scss';
</style>
